import React, { useEffect, useState } from "react";
import Header from "./Header";
import Parcours from "./Parcours";
import Competences from "./Competences";
import Contact from "./Contact";
import Portfolio from "./Portfolio";
import { BackgroundColor } from "./StyledComponents/BackgroundStyle.style";
import { CommunContainer } from "./StyledComponents/Commun.style";
import PaperTextureWide from "./asset/pictures/paper-texture-wide.png";
import "./style.css";
const Background = () => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const onScroll = (e) => {
      setScrollTop(e.target.documentElement.scrollTop);
      const img = document.getElementsByClassName("imgParallax");
      imgParallax();
      return img;
    };
    window.addEventListener("scroll", onScroll);
  }, [scrollTop]);

  const imgParallax = () => {
    if (scrollTop) return false;
    return true;
  };

  return (
    <>
      <CommunContainer>
        <BackgroundColor backgroundImg={PaperTextureWide}>
          <Header />
        </BackgroundColor>
        <Parcours />
        <Competences />
        <Portfolio />
        <Contact />
      </CommunContainer>
    </>
  );
};

export default Background;
